import {numberFormat} from "@pg-mono/string-utils";

import {getOfferTypeNamePlural} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {getPageTitle} from "../utils/get_page_title";

export interface ITitleOfferDetail {
    offerName: string;
    offerType: OfferType;
    regionName: string;
    isSpain: boolean;
    parentRegionName: string;
    isDistrictOrNeighborhood?: boolean;
    minPrice?: number | null;
}

export const titleOfferDetail = (props: ITitleOfferDetail) => {
    const type = getOfferTypeNamePlural(props.offerType);
    const regionPart = props.regionName.split(",")[0].trim();
    const pricePart = props.minPrice ? ` od ${numberFormat(Math.round(props.minPrice))} zł` : "";

    if (props.isSpain) {
        return getPageTitle(`${props.offerName} - ${type} Hiszpania, ${props.parentRegionName}`);
    }

    return getPageTitle(`${props.offerName.toUpperCase()} ${regionPart}: ${type}${pricePart}`);
};
import {numberFormat} from "@pg-mono/string-utils";

import {getOfferTypeNamePlural} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {getPageTitle} from "../utils/get_page_title";

export interface ITitleOfferDetail {
    offerName: string;
    offerType: OfferType;
    regionName: string;
    isSpain: boolean;
    parentRegionName: string;
    isDistrictOrNeighborhood?: boolean;
    minPrice?: number | null;
}

export const titleOfferDetail = (props: ITitleOfferDetail) => {
    const type = getOfferTypeNamePlural(props.offerType);
    const regionPart = props.regionName.split(",")[0].trim();
    const pricePart = props.minPrice ? ` od ${numberFormat(Math.round(props.minPrice))} zł` : "";

    if (props.isSpain) {
        return getPageTitle(`${props.offerName} - ${type} Hiszpania, ${props.parentRegionName}`);
    }

    return getPageTitle(`${props.offerName.toUpperCase()} ${regionPart}: ${type}${pricePart}`);
};
